// import React, { useState, useEffect, useRef } from "react";
// import ReactDOM from "react-dom";
// import {
//   FaBell,
//   FaTimes,
//   FaExternalLinkAlt,
//   FaCalendarAlt,
//   FaChevronRight,
//   FaInfoCircle,
//   FaExclamationTriangle,
//   FaCheckCircle,
//   FaNewspaper,
//   FaBullhorn,
//   FaGift,
// } from "react-icons/fa";
// import axios from "../../utils/axiosConfig";
// import toast from "react-hot-toast";

// const NotificationBell = ({ isDarkMode }) => {
//   const [isOpen, setIsOpen] = useState(false);
//   const [announcements, setAnnouncements] = useState([]);
//   const [unreadCount, setUnreadCount] = useState(0);
//   const [loading, setLoading] = useState(false);
//   const [isEnabled, setIsEnabled] = useState(true);
//   const [selectedAnnouncement, setSelectedAnnouncement] = useState(null);
//   const [buttonPosition, setButtonPosition] = useState({ top: 0, right: 0 });
//   const buttonRef = useRef(null);
//   const dropdownRef = useRef(null);

//   useEffect(() => {
//     fetchAnnouncements();
//     const interval = setInterval(fetchAnnouncements, 120000);
//     return () => clearInterval(interval);
//   }, []);

//   // Close dropdown when clicking outside
//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (
//         dropdownRef.current &&
//         !dropdownRef.current.contains(event.target) &&
//         buttonRef.current &&
//         !buttonRef.current.contains(event.target)
//       ) {
//         setIsOpen(false);
//       }
//     };
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => document.removeEventListener("mousedown", handleClickOutside);
//   }, []);

//   const fetchAnnouncements = async () => {
//     setLoading(true);
//     try {
//       const response = await axios.get("/api/announcements/active");
//       if (response.data.success) {
//         setIsEnabled(response.data.enabled);
//         setAnnouncements(response.data.announcements);
//         setUnreadCount(response.data.unreadCount);
//       }
//     } catch (error) {
//       console.error("Fetch announcements error:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleMarkAsRead = async (announcementId) => {
//     try {
//       await axios.post(`/api/announcements/${announcementId}/seen`);
//       setAnnouncements((prev) =>
//         prev.map((a) =>
//           a._id === announcementId
//             ? { ...a, seenBy: [...(a.seenBy || []), { user: {} }] }
//             : a,
//         ),
//       );
//       setUnreadCount((prev) => Math.max(0, prev - 1));
//     } catch (error) {
//       console.error("Mark as read error:", error);
//     }
//   };

//   const handleDismiss = async (announcementId, e) => {
//     if (e) e.stopPropagation();
//     try {
//       await axios.post(`/api/announcements/${announcementId}/dismiss`);
//       // Immediately refetch to update the list
//       await fetchAnnouncements();
//       toast.success("Announcement dismissed");
//       if (selectedAnnouncement?._id === announcementId) {
//         setSelectedAnnouncement(null);
//       }
//     } catch (error) {
//       console.error("Dismiss error:", error);
//       toast.error("Failed to dismiss");
//     }
//   };

//   const handleOpenPopup = (announcement) => {
//     setSelectedAnnouncement(announcement);
//     setIsOpen(false);
//     const hasSeen = announcement.seenBy?.some(
//       (s) => s.user === localStorage.getItem("userId"),
//     );
//     if (!hasSeen) {
//       handleMarkAsRead(announcement._id);
//     }
//   };

//   const handleClosePopup = () => {
//     setSelectedAnnouncement(null);
//   };

//   const handleButtonClick = () => {
//     if (buttonRef.current) {
//       const rect = buttonRef.current.getBoundingClientRect();
//       setButtonPosition({
//         top: rect.bottom + window.scrollY + 8,
//         right: window.innerWidth - rect.right,
//       });
//     }
//     setIsOpen(!isOpen);
//   };

//   const getTypeStyles = (type) => {
//     const styles = {
//       info: {
//         bg: "#3b82f6",
//         icon: <FaInfoCircle size={16} />,
//         gradient: "linear-gradient(135deg, #3b82f6, #2563eb)",
//         label: "Info",
//       },
//       warning: {
//         bg: "#f59e0b",
//         icon: <FaExclamationTriangle size={16} />,
//         gradient: "linear-gradient(135deg, #f59e0b, #d97706)",
//         label: "Warning",
//       },
//       success: {
//         bg: "#10b981",
//         icon: <FaCheckCircle size={16} />,
//         gradient: "linear-gradient(135deg, #10b981, #059669)",
//         label: "Success",
//       },
//       event: {
//         bg: "#8b5cf6",
//         icon: <FaCalendarAlt size={16} />,
//         gradient: "linear-gradient(135deg, #8b5cf6, #6d28d9)",
//         label: "Event",
//       },
//       promotion: {
//         bg: "#ec4899",
//         icon: <FaGift size={16} />,
//         gradient: "linear-gradient(135deg, #ec4899, #be185d)",
//         label: "Promotion",
//       },
//       emergency: {
//         bg: "#ef4444",
//         icon: <FaExclamationTriangle size={16} />,
//         gradient: "linear-gradient(135deg, #ef4444, #dc2626)",
//         label: "Emergency",
//       },
//     };
//     return styles[type] || styles.info;
//   };

//   const getTextColor = () => (isDarkMode ? "#f1f5f9" : "#1e293b");
//   const getTextSecondary = () => (isDarkMode ? "#94a3b8" : "#64748b");
//   const getBorderColor = () =>
//     isDarkMode ? "rgba(139,92,246,0.2)" : "rgba(139,92,246,0.1)";
//   const getCardBackground = () =>
//     isDarkMode ? "rgba(30, 30, 45, 0.95)" : "rgba(255, 255, 255, 0.95)";

//   if (!isEnabled) {
//     return null;
//   }

//   // Popup Modal
//   const PopupModal = () => {
//     if (!selectedAnnouncement) return null;

//     const typeStyle = getTypeStyles(selectedAnnouncement.type);

//     return ReactDOM.createPortal(
//       <div
//         style={{
//           position: "fixed",
//           top: 0,
//           left: 0,
//           right: 0,
//           bottom: 0,
//           background: "rgba(0,0,0,0.85)",
//           backdropFilter: "blur(12px)",
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "center",
//           zIndex: 100000,
//         }}
//         onClick={handleClosePopup}
//       >
//         <div
//           style={{
//             width: "90%",
//             maxWidth: "500px",
//             maxHeight: "80vh",
//             overflow: "auto",
//             background: getCardBackground(),
//             borderRadius: "24px",
//             boxShadow: "0 25px 50px -12px rgba(0,0,0,0.5)",
//             border: `1px solid ${getBorderColor()}`,
//             pointerEvents: "auto",
//           }}
//           onClick={(e) => e.stopPropagation()}
//         >
//           <div
//             style={{
//               background: typeStyle.gradient,
//               padding: "24px",
//               color: "white",
//               position: "sticky",
//               top: 0,
//             }}
//           >
//             <div
//               style={{
//                 display: "flex",
//                 justifyContent: "space-between",
//                 alignItems: "flex-start",
//               }}
//             >
//               <div
//                 style={{ display: "flex", gap: "12px", alignItems: "center" }}
//               >
//                 <div
//                   style={{
//                     width: "48px",
//                     height: "48px",
//                     background: "rgba(255,255,255,0.2)",
//                     borderRadius: "14px",
//                     display: "flex",
//                     alignItems: "center",
//                     justifyContent: "center",
//                   }}
//                 >
//                   {typeStyle.icon}
//                 </div>
//                 <div>
//                   <span
//                     style={{
//                       fontSize: "11px",
//                       opacity: 0.9,
//                       textTransform: "uppercase",
//                       letterSpacing: "1px",
//                     }}
//                   >
//                     {typeStyle.label}
//                   </span>
//                   <h3
//                     style={{
//                       margin: "4px 0 0 0",
//                       fontSize: "1.3rem",
//                       fontWeight: "bold",
//                     }}
//                   >
//                     {selectedAnnouncement.title}
//                   </h3>
//                 </div>
//               </div>
//               <button
//                 onClick={handleClosePopup}
//                 style={{
//                   background: "rgba(255,255,255,0.15)",
//                   border: "none",
//                   borderRadius: "10px",
//                   width: "32px",
//                   height: "32px",
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent: "center",
//                   cursor: "pointer",
//                   color: "white",
//                 }}
//               >
//                 <FaTimes size={16} />
//               </button>
//             </div>
//           </div>

//           <div style={{ padding: "24px" }}>
//             <p
//               style={{
//                 color: getTextColor(),
//                 fontSize: "15px",
//                 lineHeight: "1.6",
//                 marginBottom: "20px",
//               }}
//             >
//               {selectedAnnouncement.message}
//             </p>

//             {selectedAnnouncement.imageUrl && (
//               <div
//                 style={{
//                   marginBottom: "20px",
//                   borderRadius: "12px",
//                   overflow: "hidden",
//                 }}
//               >
//                 <img
//                   src={selectedAnnouncement.imageUrl}
//                   alt={selectedAnnouncement.title}
//                   style={{
//                     width: "100%",
//                     maxHeight: "200px",
//                     objectFit: "cover",
//                   }}
//                 />
//               </div>
//             )}

//             {selectedAnnouncement.link && (
//               <a
//                 href={selectedAnnouncement.link}
//                 target="_blank"
//                 rel="noopener noreferrer"
//                 style={{
//                   display: "inline-flex",
//                   alignItems: "center",
//                   gap: "8px",
//                   padding: "10px 20px",
//                   background: "linear-gradient(135deg, #8b5cf6, #3b82f6)",
//                   color: "white",
//                   textDecoration: "none",
//                   borderRadius: "12px",
//                   fontSize: "13px",
//                   fontWeight: "500",
//                   marginBottom: "20px",
//                 }}
//               >
//                 {selectedAnnouncement.linkText || "View Details"}{" "}
//                 <FaExternalLinkAlt size={10} />
//               </a>
//             )}

//             <div
//               style={{
//                 padding: "16px",
//                 background: isDarkMode
//                   ? "rgba(139,92,246,0.08)"
//                   : "rgba(139,92,246,0.04)",
//                 borderRadius: "14px",
//               }}
//             >
//               <div
//                 style={{
//                   display: "flex",
//                   alignItems: "center",
//                   gap: "10px",
//                   fontSize: "12px",
//                   color: getTextSecondary(),
//                 }}
//               >
//                 <FaCalendarAlt size={12} color="#8b5cf6" />
//                 <span>
//                   {new Date(selectedAnnouncement.createdAt).toLocaleDateString(
//                     undefined,
//                     {
//                       year: "numeric",
//                       month: "short",
//                       day: "numeric",
//                       hour: "2-digit",
//                       minute: "2-digit",
//                     },
//                   )}
//                 </span>
//               </div>
//             </div>
//           </div>

//           <div
//             style={{
//               padding: "16px 24px",
//               borderTop: `1px solid ${getBorderColor()}`,
//               display: "flex",
//               gap: "12px",
//               justifyContent: "flex-end",
//               background: getCardBackground(),
//             }}
//           >
//             <button
//               onClick={(e) => handleDismiss(selectedAnnouncement._id, e)}
//               style={{
//                 padding: "8px 20px",
//                 background: "#6c757d",
//                 color: "white",
//                 border: "none",
//                 borderRadius: "10px",
//                 cursor: "pointer",
//                 fontSize: "13px",
//                 fontWeight: "500",
//               }}
//             >
//               Dismiss
//             </button>
//             <button
//               onClick={handleClosePopup}
//               style={{
//                 padding: "8px 24px",
//                 background: "linear-gradient(135deg, #8b5cf6, #3b82f6)",
//                 color: "white",
//                 border: "none",
//                 borderRadius: "10px",
//                 cursor: "pointer",
//                 fontSize: "13px",
//                 fontWeight: "500",
//               }}
//             >
//               Close
//             </button>
//           </div>
//         </div>
//       </div>,
//       document.body,
//     );
//   };

//   // Dropdown Menu
//   const DropdownMenu = () => {
//     if (!isOpen) return null;

//     return ReactDOM.createPortal(
//       <div
//         ref={dropdownRef}
//         style={{
//           position: "fixed",
//           top: buttonPosition.top,
//           right: buttonPosition.right,
//           width: "360px",
//           maxWidth: "90vw",
//           maxHeight: "450px",
//           background: getCardBackground(),
//           backdropFilter: "blur(20px)",
//           borderRadius: "16px",
//           boxShadow: "0 10px 40px rgba(0,0,0,0.3)",
//           border: `1px solid ${getBorderColor()}`,
//           overflow: "hidden",
//           zIndex: 10000,
//         }}
//       >
//         <div
//           style={{
//             padding: "14px 18px",
//             borderBottom: `1px solid ${getBorderColor()}`,
//             display: "flex",
//             justifyContent: "space-between",
//             alignItems: "center",
//           }}
//         >
//           <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
//             <FaBullhorn size={14} color="#ff6a00" />
//             <h3
//               style={{
//                 margin: 0,
//                 fontSize: "1rem",
//                 fontWeight: "bold",
//                 color: getTextColor(),
//               }}
//             >
//               Announcements
//             </h3>
//           </div>
//           <button
//             onClick={() => setIsOpen(false)}
//             style={{
//               background: "none",
//               border: "none",
//               cursor: "pointer",
//               color: getTextSecondary(),
//               padding: "4px",
//               borderRadius: "4px",
//             }}
//           >
//             <FaTimes size={14} />
//           </button>
//         </div>

//         <div style={{ maxHeight: "400px", overflowY: "auto" }}>
//           {loading ? (
//             <div
//               style={{
//                 padding: "2rem",
//                 textAlign: "center",
//                 color: getTextSecondary(),
//               }}
//             >
//               Loading...
//             </div>
//           ) : announcements.length === 0 ? (
//             <div
//               style={{
//                 padding: "2rem",
//                 textAlign: "center",
//                 color: getTextSecondary(),
//               }}
//             >
//               <FaNewspaper
//                 size={32}
//                 style={{ marginBottom: "8px", opacity: 0.5 }}
//               />
//               <p>No announcements</p>
//             </div>
//           ) : (
//             announcements.map((announcement) => {
//               const typeStyle = getTypeStyles(announcement.type);
//               const isUnread = !announcement.seenBy?.some(
//                 (s) => s.user === localStorage.getItem("userId"),
//               );
//               return (
//                 <div
//                   key={announcement._id}
//                   onClick={() => handleOpenPopup(announcement)}
//                   style={{
//                     padding: "12px 16px",
//                     borderBottom: `1px solid ${getBorderColor()}`,
//                     cursor: "pointer",
//                     transition: "background 0.2s",
//                     background: isUnread ? `${typeStyle.bg}15` : "transparent",
//                     borderLeft: isUnread ? `3px solid ${typeStyle.bg}` : "none",
//                   }}
//                   onMouseEnter={(e) => {
//                     e.currentTarget.style.background = isDarkMode
//                       ? "rgba(139,92,246,0.15)"
//                       : "rgba(139,92,246,0.08)";
//                   }}
//                   onMouseLeave={(e) => {
//                     e.currentTarget.style.background = isUnread
//                       ? `${typeStyle.bg}15`
//                       : "transparent";
//                   }}
//                 >
//                   <div style={{ display: "flex", gap: "10px" }}>
//                     <div
//                       style={{
//                         width: "32px",
//                         height: "32px",
//                         background: `${typeStyle.bg}20`,
//                         borderRadius: "8px",
//                         display: "flex",
//                         alignItems: "center",
//                         justifyContent: "center",
//                         color: typeStyle.bg,
//                       }}
//                     >
//                       {typeStyle.icon}
//                     </div>
//                     <div style={{ flex: 1, minWidth: 0 }}>
//                       <div
//                         style={{
//                           display: "flex",
//                           alignItems: "center",
//                           gap: "6px",
//                           flexWrap: "wrap",
//                           marginBottom: "4px",
//                         }}
//                       >
//                         <span
//                           style={{
//                             fontSize: "9px",
//                             fontWeight: "600",
//                             background: typeStyle.bg,
//                             color: "white",
//                             padding: "2px 6px",
//                             borderRadius: "8px",
//                           }}
//                         >
//                           {typeStyle.label}
//                         </span>
//                         {announcement.priority >= 7 && (
//                           <span
//                             style={{
//                               fontSize: "8px",
//                               background: "#ef4444",
//                               color: "white",
//                               padding: "2px 6px",
//                               borderRadius: "8px",
//                             }}
//                           >
//                             High Priority
//                           </span>
//                         )}
//                         {isUnread && (
//                           <span
//                             style={{
//                               fontSize: "8px",
//                               background: "#8b5cf6",
//                               color: "white",
//                               padding: "2px 6px",
//                               borderRadius: "8px",
//                             }}
//                           >
//                             New
//                           </span>
//                         )}
//                       </div>
//                       <h4
//                         style={{
//                           margin: "0 0 2px 0",
//                           fontSize: "13px",
//                           fontWeight: "600",
//                           color: getTextColor(),
//                           whiteSpace: "nowrap",
//                           overflow: "hidden",
//                           textOverflow: "ellipsis",
//                         }}
//                       >
//                         {announcement.title}
//                       </h4>
//                       <p
//                         style={{
//                           margin: "0 0 4px 0",
//                           fontSize: "11px",
//                           color: getTextSecondary(),
//                           lineHeight: "1.3",
//                           display: "-webkit-box",
//                           WebkitLineClamp: 2,
//                           WebkitBoxOrient: "vertical",
//                           overflow: "hidden",
//                         }}
//                       >
//                         {announcement.message}
//                       </p>
//                       <div
//                         style={{
//                           display: "flex",
//                           alignItems: "center",
//                           justifyContent: "space-between",
//                           marginTop: "4px",
//                         }}
//                       >
//                         <div
//                           style={{
//                             display: "flex",
//                             alignItems: "center",
//                             gap: "4px",
//                             fontSize: "9px",
//                             color: getTextSecondary(),
//                           }}
//                         >
//                           <FaCalendarAlt size={9} />
//                           <span>
//                             {new Date(
//                               announcement.createdAt,
//                             ).toLocaleDateString()}
//                           </span>
//                         </div>
//                         <button
//                           onClick={(e) => handleDismiss(announcement._id, e)}
//                           style={{
//                             fontSize: "9px",
//                             color: getTextSecondary(),
//                             background: "none",
//                             border: "none",
//                             cursor: "pointer",
//                             padding: "2px 6px",
//                             borderRadius: "4px",
//                           }}
//                           onMouseEnter={(e) => {
//                             e.target.style.background = "rgba(239,68,68,0.1)";
//                             e.target.style.color = "#ef4444";
//                           }}
//                           onMouseLeave={(e) => {
//                             e.target.style.background = "transparent";
//                             e.target.style.color = getTextSecondary();
//                           }}
//                         >
//                           Dismiss
//                         </button>
//                       </div>
//                     </div>
//                     <FaChevronRight
//                       size={10}
//                       color={getTextSecondary()}
//                       style={{ alignSelf: "center", opacity: 0.5 }}
//                     />
//                   </div>
//                 </div>
//               );
//             })
//           )}
//         </div>
//       </div>,
//       document.body,
//     );
//   };

//   return (
//     <>
//       <div ref={buttonRef} style={{ display: "inline-block" }}>
//         <button
//           onClick={handleButtonClick}
//           style={{
//             position: "relative",
//             padding: "0.6rem",
//             background: isDarkMode
//               ? "rgba(255,255,255,0.05)"
//               : "rgba(0,0,0,0.05)",
//             border: `1px solid ${getBorderColor()}`,
//             borderRadius: "12px",
//             cursor: "pointer",
//             color: getTextColor(),
//             transition: "all 0.3s",
//           }}
//         >
//           <FaBell size={18} />
//           {unreadCount > 0 && (
//             <span
//               style={{
//                 position: "absolute",
//                 top: "-4px",
//                 right: "-4px",
//                 background: "#ef4444",
//                 color: "white",
//                 borderRadius: "50%",
//                 width: "18px",
//                 height: "18px",
//                 fontSize: "10px",
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: "center",
//                 fontWeight: "bold",
//               }}
//             >
//               {unreadCount > 9 ? "9+" : unreadCount}
//             </span>
//           )}
//         </button>
//       </div>

//       <DropdownMenu />
//       <PopupModal />
//     </>
//   );
// };

// export default NotificationBell;

import React, { useState, useEffect, useRef } from "react";
import ReactDOM from "react-dom";
import {
  FaBell,
  FaTimes,
  FaExternalLinkAlt,
  FaCalendarAlt,
  FaChevronRight,
  FaInfoCircle,
  FaExclamationTriangle,
  FaCheckCircle,
  FaNewspaper,
  FaBullhorn,
  FaGift,
} from "react-icons/fa";
import axios from "../../utils/axiosConfig";
import toast from "react-hot-toast";
import { useSelector } from "react-redux";

const NotificationBell = ({ isDarkMode }) => {
  const { user } = useSelector((state) => state.auth);
  const [isOpen, setIsOpen] = useState(false);
  const [announcements, setAnnouncements] = useState([]);
  const [unreadCount, setUnreadCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [isEnabled, setIsEnabled] = useState(true);
  const [selectedAnnouncement, setSelectedAnnouncement] = useState(null);
  const [buttonPosition, setButtonPosition] = useState({ top: 0, right: 0 });
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const buttonRef = useRef(null);
  const dropdownRef = useRef(null);
  const userId = user?._id || user?.id;

  // Store all seen announcement IDs in localStorage
  const [seenIds, setSeenIds] = useState(() => {
    const saved = localStorage.getItem("seenAnnouncements");
    return saved ? JSON.parse(saved) : [];
  });

  // Store dismissed announcement IDs in localStorage
  const [dismissedIds, setDismissedIds] = useState(() => {
    const saved = localStorage.getItem("dismissedAnnouncements");
    return saved ? JSON.parse(saved) : [];
  });

  // Save seen IDs to localStorage
  useEffect(() => {
    localStorage.setItem("seenAnnouncements", JSON.stringify(seenIds));
  }, [seenIds]);

  // Save dismissed IDs to localStorage
  useEffect(() => {
    localStorage.setItem(
      "dismissedAnnouncements",
      JSON.stringify(dismissedIds),
    );
  }, [dismissedIds]);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    // Try to load from sessionStorage first (cached announcements)
    const cachedAnnouncements = sessionStorage.getItem("cachedAnnouncements");
    if (cachedAnnouncements) {
      const parsed = JSON.parse(cachedAnnouncements);
      setAnnouncements(parsed);
      // Calculate unread count from cached
      const unread = parsed.filter((ann) => !seenIds.includes(ann._id)).length;
      setUnreadCount(unread);
    }

    fetchAnnouncements();
    const interval = setInterval(fetchAnnouncements, 120000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target) &&
        buttonRef.current &&
        !buttonRef.current.contains(event.target)
      ) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const fetchAnnouncements = async () => {
    setLoading(true);
    try {
      const response = await axios.get("/api/announcements/active");
      if (response.data.success) {
        setIsEnabled(response.data.enabled);

        // Get announcements from API
        let apiAnnouncements = response.data.announcements || [];

        // Mark announcements as seen if they are in seenIds
        const announcementsWithSeenStatus = apiAnnouncements.map((ann) => ({
          ...ann,
          seenBy: seenIds.includes(ann._id)
            ? [...(ann.seenBy || []), { user: userId, seenAt: new Date() }]
            : ann.seenBy,
        }));

        // Filter out locally dismissed announcements
        const filteredAnnouncements = announcementsWithSeenStatus.filter(
          (ann) => !dismissedIds.includes(ann._id),
        );

        // Cache announcements in sessionStorage
        sessionStorage.setItem(
          "cachedAnnouncements",
          JSON.stringify(filteredAnnouncements),
        );

        setAnnouncements(filteredAnnouncements);

        // Calculate unread count
        const unread = filteredAnnouncements.filter((ann) => {
          return !ann.seenBy?.some((s) => s.user === userId);
        }).length;

        setUnreadCount(unread);
      }
    } catch (error) {
      console.error("Fetch announcements error:", error);
      // If API fails, keep cached announcements
      const cached = sessionStorage.getItem("cachedAnnouncements");
      if (cached) {
        const parsed = JSON.parse(cached);
        setAnnouncements(parsed);
        const unread = parsed.filter(
          (ann) => !seenIds.includes(ann._id),
        ).length;
        setUnreadCount(unread);
      }
    } finally {
      setLoading(false);
    }
  };

  const handleMarkAsRead = async (announcementId) => {
    try {
      await axios.post(`/api/announcements/${announcementId}/seen`);

      // Add to seenIds in localStorage
      if (!seenIds.includes(announcementId)) {
        setSeenIds((prev) => [...prev, announcementId]);
      }

      // Update local state
      setAnnouncements((prev) =>
        prev.map((a) =>
          a._id === announcementId
            ? {
                ...a,
                seenBy: [
                  ...(a.seenBy || []),
                  { user: userId, seenAt: new Date() },
                ],
              }
            : a,
        ),
      );

      // Update cached announcements
      const cached = sessionStorage.getItem("cachedAnnouncements");
      if (cached) {
        const parsed = JSON.parse(cached);
        const updated = parsed.map((a) =>
          a._id === announcementId
            ? {
                ...a,
                seenBy: [
                  ...(a.seenBy || []),
                  { user: userId, seenAt: new Date() },
                ],
              }
            : a,
        );
        sessionStorage.setItem("cachedAnnouncements", JSON.stringify(updated));
      }

      setUnreadCount((prev) => Math.max(0, prev - 1));
    } catch (error) {
      console.error("Mark as read error:", error);
    }
  };

  const handleDismiss = async (announcementId, e) => {
    if (e) e.stopPropagation();
    try {
      await axios.post(`/api/announcements/${announcementId}/dismiss`);

      // Add to dismissed IDs in localStorage
      setDismissedIds((prev) => [...prev, announcementId]);

      // Remove from local state
      setAnnouncements((prev) => prev.filter((a) => a._id !== announcementId));

      // Update cached announcements
      const cached = sessionStorage.getItem("cachedAnnouncements");
      if (cached) {
        const parsed = JSON.parse(cached);
        const updated = parsed.filter((a) => a._id !== announcementId);
        sessionStorage.setItem("cachedAnnouncements", JSON.stringify(updated));
      }

      // Update unread count if needed
      setUnreadCount((prev) => {
        const wasUnread =
          announcements
            .find((a) => a._id === announcementId)
            ?.seenBy?.some((s) => s.user === userId) === false;
        return wasUnread ? Math.max(0, prev - 1) : prev;
      });

      toast.success("Announcement dismissed");
      if (selectedAnnouncement?._id === announcementId) {
        setSelectedAnnouncement(null);
      }
    } catch (error) {
      console.error("Dismiss error:", error);
      toast.error("Failed to dismiss");
    }
  };

  const handleOpenPopup = (announcement) => {
    setSelectedAnnouncement(announcement);
    setIsOpen(false);
    const hasSeen =
      announcement.seenBy?.some((s) => s.user === userId) ||
      seenIds.includes(announcement._id);
    if (!hasSeen) {
      handleMarkAsRead(announcement._id);
    }
  };

  const handleClosePopup = () => {
    setSelectedAnnouncement(null);
  };

  const handleButtonClick = () => {
    if (buttonRef.current) {
      const rect = buttonRef.current.getBoundingClientRect();
      setButtonPosition({
        top: rect.bottom + window.scrollY + 8,
        right: window.innerWidth - rect.right,
      });
    }
    setIsOpen(!isOpen);
  };

  const getTypeStyles = (type) => {
    const styles = {
      info: {
        bg: "#3b82f6",
        icon: <FaInfoCircle size={16} />,
        gradient: "linear-gradient(135deg, #3b82f6, #2563eb)",
        label: "Info",
      },
      warning: {
        bg: "#f59e0b",
        icon: <FaExclamationTriangle size={16} />,
        gradient: "linear-gradient(135deg, #f59e0b, #d97706)",
        label: "Warning",
      },
      success: {
        bg: "#10b981",
        icon: <FaCheckCircle size={16} />,
        gradient: "linear-gradient(135deg, #10b981, #059669)",
        label: "Success",
      },
      event: {
        bg: "#8b5cf6",
        icon: <FaCalendarAlt size={16} />,
        gradient: "linear-gradient(135deg, #8b5cf6, #6d28d9)",
        label: "Event",
      },
      promotion: {
        bg: "#ec4899",
        icon: <FaGift size={16} />,
        gradient: "linear-gradient(135deg, #ec4899, #be185d)",
        label: "Promotion",
      },
      emergency: {
        bg: "#ef4444",
        icon: <FaExclamationTriangle size={16} />,
        gradient: "linear-gradient(135deg, #ef4444, #dc2626)",
        label: "Emergency",
      },
    };
    return styles[type] || styles.info;
  };

  const getTextColor = () => (isDarkMode ? "#f1f5f9" : "#1e293b");
  const getTextSecondary = () => (isDarkMode ? "#94a3b8" : "#64748b");
  const getBorderColor = () =>
    isDarkMode ? "rgba(139,92,246,0.2)" : "rgba(139,92,246,0.1)";
  const getCardBackground = () =>
    isDarkMode ? "rgba(30, 30, 45, 0.95)" : "rgba(255, 255, 255, 0.95)";

  if (!isEnabled) {
    return null;
  }

  // Popup Modal (same as before - kept for brevity, but use the same updated version)
  const PopupModal = () => {
    if (!selectedAnnouncement) return null;
    const typeStyle = getTypeStyles(selectedAnnouncement.type);

    return ReactDOM.createPortal(
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: "rgba(0,0,0,0.85)",
          backdropFilter: "blur(12px)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          zIndex: 100000,
          padding: isMobile ? "16px" : "20px",
        }}
        onClick={handleClosePopup}
      >
        <div
          style={{
            width: "100%",
            maxWidth: "500px",
            maxHeight: "85vh",
            overflow: "auto",
            background: getCardBackground(),
            borderRadius: "24px",
            boxShadow: "0 25px 50px -12px rgba(0,0,0,0.5)",
            border: `1px solid ${getBorderColor()}`,
            pointerEvents: "auto",
          }}
          onClick={(e) => e.stopPropagation()}
        >
          <div
            style={{
              background: typeStyle.gradient,
              padding: isMobile ? "20px" : "24px",
              color: "white",
              position: "sticky",
              top: 0,
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "flex-start",
              }}
            >
              <div
                style={{
                  display: "flex",
                  gap: "12px",
                  alignItems: "center",
                  flex: 1,
                }}
              >
                <div
                  style={{
                    width: "44px",
                    height: "44px",
                    background: "rgba(255,255,255,0.2)",
                    borderRadius: "14px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  {typeStyle.icon}
                </div>
                <div>
                  <span
                    style={{
                      fontSize: "11px",
                      opacity: 0.9,
                      textTransform: "uppercase",
                      letterSpacing: "1px",
                    }}
                  >
                    {typeStyle.label}
                  </span>
                  <h3
                    style={{
                      margin: "4px 0 0 0",
                      fontSize: isMobile ? "1.1rem" : "1.3rem",
                      fontWeight: "bold",
                      wordBreak: "break-word",
                    }}
                  >
                    {selectedAnnouncement.title}
                  </h3>
                </div>
              </div>
              <button
                onClick={handleClosePopup}
                style={{
                  background: "rgba(255,255,255,0.15)",
                  border: "none",
                  borderRadius: "10px",
                  width: "32px",
                  height: "32px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: "pointer",
                  color: "white",
                  flexShrink: 0,
                }}
              >
                <FaTimes size={16} />
              </button>
            </div>
          </div>

          <div style={{ padding: isMobile ? "20px" : "24px" }}>
            <p
              style={{
                color: getTextColor(),
                fontSize: isMobile ? "14px" : "15px",
                lineHeight: "1.6",
                marginBottom: "20px",
                whiteSpace: "pre-wrap",
                wordBreak: "break-word",
              }}
            >
              {selectedAnnouncement.message}
            </p>

            {selectedAnnouncement.imageUrl && (
              <div
                style={{
                  marginBottom: "20px",
                  borderRadius: "12px",
                  overflow: "hidden",
                }}
              >
                <img
                  src={selectedAnnouncement.imageUrl}
                  alt={selectedAnnouncement.title}
                  style={{
                    width: "100%",
                    maxHeight: "200px",
                    objectFit: "cover",
                  }}
                />
              </div>
            )}

            {selectedAnnouncement.link && (
              <a
                href={selectedAnnouncement.link}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: "8px",
                  padding: "10px 20px",
                  background: "linear-gradient(135deg, #8b5cf6, #3b82f6)",
                  color: "white",
                  textDecoration: "none",
                  borderRadius: "12px",
                  fontSize: "13px",
                  fontWeight: "500",
                  marginBottom: "20px",
                }}
              >
                {selectedAnnouncement.linkText || "View Details"}{" "}
                <FaExternalLinkAlt size={10} />
              </a>
            )}

            <div
              style={{
                padding: "14px",
                background: isDarkMode
                  ? "rgba(139,92,246,0.08)"
                  : "rgba(139,92,246,0.04)",
                borderRadius: "14px",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                  fontSize: "12px",
                  color: getTextSecondary(),
                  flexWrap: "wrap",
                }}
              >
                <FaCalendarAlt size={12} color="#8b5cf6" />
                <span>
                  {new Date(selectedAnnouncement.createdAt).toLocaleDateString(
                    undefined,
                    {
                      year: "numeric",
                      month: "short",
                      day: "numeric",
                      hour: "2-digit",
                      minute: "2-digit",
                    },
                  )}
                </span>
              </div>
            </div>
          </div>

          <div
            style={{
              padding: isMobile ? "16px 20px" : "16px 24px",
              borderTop: `1px solid ${getBorderColor()}`,
              display: "flex",
              gap: "12px",
              justifyContent: "flex-end",
              background: getCardBackground(),
            }}
          >
            <button
              onClick={(e) => handleDismiss(selectedAnnouncement._id, e)}
              style={{
                padding: isMobile ? "8px 16px" : "8px 20px",
                background: "#6c757d",
                color: "white",
                border: "none",
                borderRadius: "10px",
                cursor: "pointer",
                fontSize: "13px",
                fontWeight: "500",
              }}
            >
              Dismiss
            </button>
            <button
              onClick={handleClosePopup}
              style={{
                padding: isMobile ? "8px 20px" : "8px 24px",
                background: "linear-gradient(135deg, #8b5cf6, #3b82f6)",
                color: "white",
                border: "none",
                borderRadius: "10px",
                cursor: "pointer",
                fontSize: "13px",
                fontWeight: "500",
              }}
            >
              Close
            </button>
          </div>
        </div>
      </div>,
      document.body,
    );
  };

  // Dropdown Menu (same as before but using updated state)
  const DropdownMenu = () => {
    if (!isOpen) return null;

    const visibleAnnouncements = announcements.filter((ann) => {
      return !dismissedIds.includes(ann._id);
    });

    if (isMobile) {
      return ReactDOM.createPortal(
        <div
          ref={dropdownRef}
          style={{
            position: "fixed",
            bottom: 0,
            left: 0,
            right: 0,
            top: "auto",
            background: getCardBackground(),
            backdropFilter: "blur(20px)",
            borderRadius: "20px 20px 0 0",
            boxShadow: "0 -5px 30px rgba(0,0,0,0.3)",
            borderTop: `1px solid ${getBorderColor()}`,
            overflow: "hidden",
            zIndex: 10000,
            maxHeight: "80vh",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              padding: "12px 0 8px 0",
            }}
          >
            <div
              style={{
                width: "40px",
                height: "4px",
                background: getTextSecondary(),
                borderRadius: "2px",
                opacity: 0.5,
              }}
            />
          </div>

          <div
            style={{
              padding: "12px 20px",
              borderBottom: `1px solid ${getBorderColor()}`,
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              flexShrink: 0,
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <FaBullhorn size={16} color="#8b5cf6" />
              <h3
                style={{
                  margin: 0,
                  fontSize: "1rem",
                  fontWeight: "bold",
                  color: getTextColor(),
                }}
              >
                Announcements
              </h3>
              {unreadCount > 0 && (
                <span
                  style={{
                    background: "#ef4444",
                    color: "white",
                    padding: "2px 8px",
                    borderRadius: "20px",
                    fontSize: "10px",
                    fontWeight: "bold",
                  }}
                >
                  {unreadCount} new
                </span>
              )}
            </div>
            <button
              onClick={() => setIsOpen(false)}
              style={{
                background: "none",
                border: "none",
                cursor: "pointer",
                color: getTextSecondary(),
                padding: "4px",
                borderRadius: "4px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <FaTimes size={16} />
            </button>
          </div>

          <div
            style={{
              flex: 1,
              overflowY: "auto",
              padding: "8px 0",
            }}
          >
            {loading ? (
              <div
                style={{
                  padding: "3rem",
                  textAlign: "center",
                  color: getTextSecondary(),
                }}
              >
                Loading...
              </div>
            ) : visibleAnnouncements.length === 0 ? (
              <div
                style={{
                  padding: "3rem",
                  textAlign: "center",
                  color: getTextSecondary(),
                }}
              >
                <FaNewspaper
                  size={48}
                  style={{ marginBottom: "12px", opacity: 0.5 }}
                />
                <p style={{ margin: 0, fontSize: "14px" }}>No announcements</p>
              </div>
            ) : (
              visibleAnnouncements.map((announcement) => {
                const typeStyle = getTypeStyles(announcement.type);
                const isUnread =
                  !seenIds.includes(announcement._id) &&
                  !announcement.seenBy?.some((s) => s.user === userId);
                return (
                  <div
                    key={announcement._id}
                    onClick={() => handleOpenPopup(announcement)}
                    style={{
                      padding: "14px 16px",
                      borderBottom: `1px solid ${getBorderColor()}`,
                      cursor: "pointer",
                      transition: "background 0.2s",
                      background: "transparent",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.background = isDarkMode
                        ? "rgba(139,92,246,0.15)"
                        : "rgba(139,92,246,0.08)";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.background = "transparent";
                    }}
                  >
                    <div style={{ display: "flex", gap: "12px" }}>
                      <div
                        style={{
                          width: "40px",
                          height: "40px",
                          background: `${typeStyle.bg}15`,
                          borderRadius: "10px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          color: typeStyle.bg,
                          flexShrink: 0,
                        }}
                      >
                        {typeStyle.icon}
                      </div>
                      <div style={{ flex: 1, minWidth: 0 }}>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "6px",
                            flexWrap: "wrap",
                            marginBottom: "6px",
                          }}
                        >
                          <span
                            style={{
                              fontSize: "10px",
                              fontWeight: "600",
                              background: typeStyle.bg,
                              color: "white",
                              padding: "2px 8px",
                              borderRadius: "12px",
                            }}
                          >
                            {typeStyle.label}
                          </span>
                          {announcement.priority >= 7 && (
                            <span
                              style={{
                                fontSize: "9px",
                                background: "#ef4444",
                                color: "white",
                                padding: "2px 8px",
                                borderRadius: "12px",
                              }}
                            >
                              High Priority
                            </span>
                          )}
                          {!isUnread && (
                            <span
                              style={{
                                fontSize: "9px",
                                background: "#6c757d",
                                color: "white",
                                padding: "2px 8px",
                                borderRadius: "12px",
                              }}
                            >
                              Read
                            </span>
                          )}
                        </div>
                        <h4
                          style={{
                            margin: "0 0 6px 0",
                            fontSize: "14px",
                            fontWeight: isUnread ? "600" : "500",
                            color: getTextColor(),
                            lineHeight: "1.3",
                          }}
                        >
                          {announcement.title}
                        </h4>
                        <p
                          style={{
                            margin: "0 0 8px 0",
                            fontSize: "12px",
                            color: getTextSecondary(),
                            lineHeight: "1.4",
                            display: "-webkit-box",
                            WebkitLineClamp: 2,
                            WebkitBoxOrient: "vertical",
                            overflow: "hidden",
                          }}
                        >
                          {announcement.message}
                        </p>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            marginTop: "4px",
                            flexWrap: "wrap",
                            gap: "8px",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "6px",
                              fontSize: "10px",
                              color: getTextSecondary(),
                            }}
                          >
                            <FaCalendarAlt size={10} />
                            <span>
                              {new Date(
                                announcement.createdAt,
                              ).toLocaleDateString()}
                            </span>
                          </div>
                          <button
                            onClick={(e) => handleDismiss(announcement._id, e)}
                            style={{
                              fontSize: "11px",
                              color: getTextSecondary(),
                              background: "none",
                              border: "none",
                              cursor: "pointer",
                              padding: "4px 10px",
                              borderRadius: "8px",
                              transition: "all 0.2s",
                            }}
                            onMouseEnter={(e) => {
                              e.target.style.background =
                                "rgba(239,68,68,0.15)";
                              e.target.style.color = "#ef4444";
                            }}
                            onMouseLeave={(e) => {
                              e.target.style.background = "transparent";
                              e.target.style.color = getTextSecondary();
                            }}
                          >
                            Dismiss
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })
            )}
          </div>

          {visibleAnnouncements.length > 0 && (
            <div
              style={{
                padding: "12px 16px",
                borderTop: `1px solid ${getBorderColor()}`,
                textAlign: "center",
                fontSize: "11px",
                color: getTextSecondary(),
                background: getCardBackground(),
                flexShrink: 0,
              }}
            >
              Tap on an announcement to view full details
            </div>
          )}
        </div>,
        document.body,
      );
    }

    return ReactDOM.createPortal(
      <div
        ref={dropdownRef}
        style={{
          position: "fixed",
          top: buttonPosition.top,
          right: Math.max(16, buttonPosition.right),
          width: "380px",
          maxWidth: "calc(100vw - 32px)",
          maxHeight: "500px",
          background: getCardBackground(),
          backdropFilter: "blur(20px)",
          borderRadius: "20px",
          boxShadow: "0 20px 40px rgba(0,0,0,0.3)",
          border: `1px solid ${getBorderColor()}`,
          overflow: "hidden",
          zIndex: 10000,
          display: "flex",
          flexDirection: "column",
        }}
      >
        <div
          style={{
            padding: "16px 20px",
            borderBottom: `1px solid ${getBorderColor()}`,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            flexShrink: 0,
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <FaBullhorn size={16} color="#8b5cf6" />
            <h3
              style={{
                margin: 0,
                fontSize: "1rem",
                fontWeight: "bold",
                color: getTextColor(),
              }}
            >
              Announcements
            </h3>
            {unreadCount > 0 && (
              <span
                style={{
                  background: "#ef4444",
                  color: "white",
                  padding: "2px 8px",
                  borderRadius: "20px",
                  fontSize: "10px",
                  fontWeight: "bold",
                }}
              >
                {unreadCount} new
              </span>
            )}
          </div>
          <button
            onClick={() => setIsOpen(false)}
            style={{
              background: "none",
              border: "none",
              cursor: "pointer",
              color: getTextSecondary(),
              padding: "4px",
              borderRadius: "4px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <FaTimes size={14} />
          </button>
        </div>

        <div
          style={{
            flex: 1,
            overflowY: "auto",
            padding: "8px 0",
          }}
        >
          {loading ? (
            <div
              style={{
                padding: "3rem",
                textAlign: "center",
                color: getTextSecondary(),
              }}
            >
              Loading...
            </div>
          ) : visibleAnnouncements.length === 0 ? (
            <div
              style={{
                padding: "3rem",
                textAlign: "center",
                color: getTextSecondary(),
              }}
            >
              <FaNewspaper
                size={48}
                style={{ marginBottom: "12px", opacity: 0.5 }}
              />
              <p style={{ margin: 0, fontSize: "14px" }}>No announcements</p>
            </div>
          ) : (
            visibleAnnouncements.map((announcement) => {
              const typeStyle = getTypeStyles(announcement.type);
              const isUnread =
                !seenIds.includes(announcement._id) &&
                !announcement.seenBy?.some((s) => s.user === userId);
              return (
                <div
                  key={announcement._id}
                  onClick={() => handleOpenPopup(announcement)}
                  style={{
                    padding: "14px 16px",
                    borderBottom: `1px solid ${getBorderColor()}`,
                    cursor: "pointer",
                    transition: "background 0.2s",
                    background: "transparent",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.background = isDarkMode
                      ? "rgba(139,92,246,0.15)"
                      : "rgba(139,92,246,0.08)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.background = "transparent";
                  }}
                >
                  <div style={{ display: "flex", gap: "12px" }}>
                    <div
                      style={{
                        width: "36px",
                        height: "36px",
                        background: `${typeStyle.bg}15`,
                        borderRadius: "10px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        color: typeStyle.bg,
                        flexShrink: 0,
                      }}
                    >
                      {typeStyle.icon}
                    </div>
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "6px",
                          flexWrap: "wrap",
                          marginBottom: "6px",
                        }}
                      >
                        <span
                          style={{
                            fontSize: "9px",
                            fontWeight: "600",
                            background: typeStyle.bg,
                            color: "white",
                            padding: "2px 8px",
                            borderRadius: "12px",
                          }}
                        >
                          {typeStyle.label}
                        </span>
                        {announcement.priority >= 7 && (
                          <span
                            style={{
                              fontSize: "8px",
                              background: "#ef4444",
                              color: "white",
                              padding: "2px 8px",
                              borderRadius: "12px",
                            }}
                          >
                            High Priority
                          </span>
                        )}
                        {!isUnread && (
                          <span
                            style={{
                              fontSize: "8px",
                              background: "#6c757d",
                              color: "white",
                              padding: "2px 8px",
                              borderRadius: "12px",
                            }}
                          >
                            Read
                          </span>
                        )}
                      </div>
                      <h4
                        style={{
                          margin: "0 0 6px 0",
                          fontSize: "13px",
                          fontWeight: isUnread ? "600" : "500",
                          color: getTextColor(),
                          lineHeight: "1.3",
                        }}
                      >
                        {announcement.title}
                      </h4>
                      <p
                        style={{
                          margin: "0 0 8px 0",
                          fontSize: "11px",
                          color: getTextSecondary(),
                          lineHeight: "1.4",
                          display: "-webkit-box",
                          WebkitLineClamp: 2,
                          WebkitBoxOrient: "vertical",
                          overflow: "hidden",
                        }}
                      >
                        {announcement.message}
                      </p>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          marginTop: "4px",
                          flexWrap: "wrap",
                          gap: "8px",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "6px",
                            fontSize: "9px",
                            color: getTextSecondary(),
                          }}
                        >
                          <FaCalendarAlt size={9} />
                          <span>
                            {new Date(
                              announcement.createdAt,
                            ).toLocaleDateString()}
                          </span>
                        </div>
                        <button
                          onClick={(e) => handleDismiss(announcement._id, e)}
                          style={{
                            fontSize: "10px",
                            color: getTextSecondary(),
                            background: "none",
                            border: "none",
                            cursor: "pointer",
                            padding: "4px 10px",
                            borderRadius: "6px",
                            transition: "all 0.2s",
                          }}
                          onMouseEnter={(e) => {
                            e.target.style.background = "rgba(239,68,68,0.1)";
                            e.target.style.color = "#ef4444";
                          }}
                          onMouseLeave={(e) => {
                            e.target.style.background = "transparent";
                            e.target.style.color = getTextSecondary();
                          }}
                        >
                          Dismiss
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })
          )}
        </div>

        {visibleAnnouncements.length > 0 && (
          <div
            style={{
              padding: "10px 16px",
              borderTop: `1px solid ${getBorderColor()}`,
              textAlign: "center",
              fontSize: "10px",
              color: getTextSecondary(),
              background: getCardBackground(),
              flexShrink: 0,
            }}
          >
            Click on an announcement to view full details
          </div>
        )}
      </div>,
      document.body,
    );
  };

  return (
    <>
      <div ref={buttonRef} style={{ display: "inline-block" }}>
        <button
          onClick={handleButtonClick}
          style={{
            position: "relative",
            padding: "0.6rem",
            background: isDarkMode
              ? "rgba(255,255,255,0.05)"
              : "rgba(0,0,0,0.05)",
            border: `1px solid ${getBorderColor()}`,
            borderRadius: "12px",
            cursor: "pointer",
            color: getTextColor(),
            transition: "all 0.3s",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <FaBell size={18} />
          {unreadCount > 0 && (
            <span
              style={{
                position: "absolute",
                top: "-4px",
                right: "-4px",
                background: "#ef4444",
                color: "white",
                borderRadius: "50%",
                width: "18px",
                height: "18px",
                fontSize: "10px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontWeight: "bold",
              }}
            >
              {unreadCount > 9 ? "9+" : unreadCount}
            </span>
          )}
        </button>
      </div>

      <DropdownMenu />
      <PopupModal />
    </>
  );
};

export default NotificationBell;
